// 添付ファイルアップロード中表示
<template>
  <div :class="fullscreen ? '' : 'modal-loading'">
    <loading :fullscreen="fullscreen" :msg="msg" />
  </div>
</template>

<style scoped>
.modal-loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import Loading from "./Loading.vue";

export default defineComponent({
  name: "loading-upload",
  components: { Loading },
  props: {
    fullscreen: { type: Boolean, default: true },
    msg: { type: String, default: "" },
  },
});
</script>
